import { User } from 'types/auth'

import { isNeverPaidUser } from '@/utils/user/isNeverPaidUser'

type TResolveHasGeneratorSidebarParams = {
	user?: User | null
	hasSessionCookie: boolean
	sessionUnauthorized: boolean
	isPostSignUpVisit: boolean
	pathnameStartsWithTypeStep: boolean
	isEditMode: boolean
	isChangeTypeMode: boolean
}

export const resolveHasGeneratorSidebar = ({
	user,
	hasSessionCookie,
	sessionUnauthorized,
	isPostSignUpVisit,
	pathnameStartsWithTypeStep,
	isEditMode,
	isChangeTypeMode,
}: TResolveHasGeneratorSidebarParams): boolean => {
	if (isNeverPaidUser(user)) {
		return false
	}

	const isSignedIn =
		Boolean(user) || (hasSessionCookie && !sessionUnauthorized)

	return Boolean(
		(!isPostSignUpVisit && isSignedIn && pathnameStartsWithTypeStep) ||
			isEditMode ||
			isChangeTypeMode,
	)
}
